// extracted by mini-css-extract-plugin
export default {"lable":"i2_lable__K4pWQ","duo":"i2_duo__u+cgC","cover":"i2_cover__jqeHb","duo2":"i2_duo2__Du6Tl","cover2":"i2_cover2__7YVXK"};